import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  private service = 'tenant-http';

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) { }

  lookup(origin: string) {
    origin = encodeURIComponent(origin);
    return this.apiService.get(this.service, 'v1/hostnames/lookup/' + origin);
  }

  check(fqdn: string) {
    return this.apiService.get(this.service, 'v1/system/hostname/check/' + fqdn);
  }
}
